// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1119":"cc1e1962","2589":"d58c8f4e","2632":"2ed3da48","2768":"69b33939","5522":"9b6f6e49"}[chunkId] + ".css";
};